const timeDelay = 300;
const closeClass = 'b-spoiler__button_theme_close';

class Spoiler {
    constructor($spoiler) {
        this.$spoiler = $spoiler;
        this.$content = this.$spoiler.find('.j-spoiler-content');
        this.$button = this.$spoiler.find('.j-spoiler-button');
    }

    init() {
        this._bindEvents();
    }

    _bindEvents() {
        this.$button.on('click', this._onClickButton.bind(this));
    }

    _onClickButton() {
        this._toggleVisibleContent();
        this._changeStateButton();
    }

    _toggleVisibleContent() {
        this.$content.slideToggle(timeDelay);
    }

    _changeStateButton() {
        const $buttonName = this.$spoiler.find('.b-spoiler__button-name');
        const currentText = $buttonName.text();
        const newText = $buttonName.data('text');

        this.$button
            .toggleClass(closeClass);
        $buttonName
            .text(newText)
            .data('text', currentText);
    }
}

export default Spoiler;
